<template>

    <v-modal title="Add Customer">

        <template #nav>
            <a :class="{ active: tab === 'single' }" href="#" @click.prevent="selectTab('single')">One Email</a>
            <a :class="{ active: tab === 'multiple' }" href="#" @click.prevent="selectTab('multiple')">Multiple Emails</a>
            <a :class="{ active: tab === 'upload' }" href="#" @click.prevent="selectTab('upload')">Upload CSV</a>
            <a :class="{ active: tab === 'zapier' }" href="#" @click.prevent="selectTab('zapier')">Zapier</a>
        </template>

        <template #body>
            <v-alert :message="error" />
            <template v-if="tab === 'single'">
                <form @submit.prevent="createCustomer">
                    <v-form-group dir="ver" label="Email Address">
                        <v-input placeholder="jane@acme.com" type="email" :model="params.email" @input="params.email = $event" />
                    </v-form-group>
                </form>
            </template>
            <template v-else-if="tab === 'multiple'">
                <v-form-group dir="ver" label="Email Addresses (separate with commas)">
                    <v-textarea placeholder="jane@acme.com, jon@acme.com, ..." :model="params.emails" @input="params.emails = $event" />
                </v-form-group>
            </template>
            <template v-else-if="tab === 'upload'">
                <v-alert type="info">File must include headers for field names. user_id or email column must be present.</v-alert>
                <v-form-group dir="ver" label="CSV File">
                    <v-uploader-file @input="params.file = $event" />
                </v-form-group>
                <p class="small"><a href="/csv/customers.csv" download><i class="fas fa-file mr-5"></i>Download Example</a></p>
            </template>
            <template v-else-if="tab === 'zapier'">
                <v-notice size="sm">
                    <template #body>
                        <v-icon class="mb-15" symbol="action-zapier" :size="40" :radius="5" />
                        <p>Import customer data from<br>thousands of apps with Zapier.</p>
                    </template>
                </v-notice>
            </template>
        </template>

        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button v-if="tab === 'single'" size="sm" :loading="loading" @click.native="createCustomer">Add Customer</v-button>
            <v-button v-if="tab === 'multiple'" size="sm" :loading="loading" @click.native="createCustomers">Add Customers</v-button>
            <v-button v-if="tab === 'upload'" size="sm" :loading="loading" @click.native="createCustomersWithCSV">Upload CSV</v-button>
            <v-button v-if="tab === 'zapier'" size="sm" :loading="loading" @click.native="createCustomerWithZapier">Visit Zapier</v-button>
        </template>

    </v-modal>

</template>

<script>

import CompanyApi from '@api/CompanyApi'
import ProjectApi from '@api/ProjectApi'

export default {

    data() {
        return {
            tab: 'single',
            loading: false,
            error: null,
            params: {},
        }
    },

    methods: {

        selectTab(tab) {
            this.tab = tab;
            this.error = null;
            this.params = {};
        },

        createCustomer() {
            this.loading = true;
            ProjectApi.createCustomer(this.project.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.$emit('saved');
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                    this.$store.commit('showModal', false);
                    CompanyApi.getCompany(this.$store.getters.company.id);
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        createCustomers() {
            this.loading = true;
            let emails = this.params.emails.split(',').map(e => {
                return e.trim();
            });
            ProjectApi.createCustomers(this.project.id, { emails: emails })
                .then((response) => {
                    this.loading = false;
                    this.$emit('saved');
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                    this.$store.commit('showModal', false);
                    CompanyApi.getCompany(this.$store.getters.company.id);
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        createCustomersWithCSV() {
            this.loading = true;
            let params = new FormData();
            params.append('file', this.params.file);
            ProjectApi.createCustomersWithCSV(this.project.id, params)
                .then((response) => {
                    this.loading = false;
                    this.$emit('saved');
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                    this.$store.commit('showModal', false);
                    CompanyApi.getCompany(this.$store.getters.company.id);
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        createCustomerWithZapier() {
            window.open('https://zapier.com/apps/crowdpower', '_blank');
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    },

}

</script>
